<section class="page">
  <header class="page-header">
    <h2>Cartouches attribuées en attente de séquençage</h2>
    <p class="subtitle">Liste les cartouches attribuées à un groupe d'amorces pour lesquelles aucune commande de séquençage n'est encore marquée.</p>
  </header>

  <section class="panel">
    <div class="actions-row">
      <button type="button" (click)="refresh()" [disabled]="loading">
        {{ loading ? 'Chargement...' : 'Actualiser la liste' }}
      </button>
      <a class="action-link" routerLink="/intranet/gestion-analyses/commandes-sequencage/passees">Commandes de séquençage passées</a>
    </div>

    @if (error) {
      <p class="error">{{ error }}</p>
    }

    @if (loading) {
      <p class="meta">Chargement des cartouches attribuées sans séquençage...</p>
    } @else if (items.length === 0) {
      <p class="meta">Aucune cartouche attribuée en attente de séquençage.</p>
    } @else {
      <p class="meta">{{ items.length }} cartouche(s) attribuée(s) restent à envoyer en séquençage.</p>
      <div class="table-wrap">
        <table>
          <thead>
            <tr>
              <th>Code cartouche</th>
              <th>Groupe d'amorces</th>
              <th>Codes amorces</th>
              <th>Date attribution</th>
            </tr>
          </thead>
          <tbody>
            @for (item of items; track item.code_cartouche + '-' + item.groupe_amorces) {
              <tr>
                <td>{{ item.code_cartouche }}</td>
                <td>{{ item.groupe_amorces }}</td>
                <td>{{ item.codes_amorces }}</td>
                <td>{{ formatDate(item.date_attribution) || '-' }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </section>
</section>